module.exports = {"path":"/404.html","layout":"page","body":"<h1>NOT FOUND</h1>\n<p>You just hit a route that doesn’t exist… the sadness.</p>\n"}


// WEBPACK FOOTER //
// ../~/gatsby/dist/loaders/markdown-loader?{"config":{"siteTitle":"Textkrieg","siteDescr":"awkwardness as a service","siteAuthor":"Ada Blitz","siteTwitterUrl":"https:/twitter.com/bangpowwww","siteEmailUrl":"mail-to:kontakt@textkrieg.de","googleAnalyticsId":"","linkPrefix":"/gatsby-starter-lumen"}}!./404.md